module.exports = __webpack_public_path__ + "images/pages/for_business/sp/case3_878caee36537d2047711781e161484e8.png";